<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="契約回線詳細情報"
  >
    <template v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row class="mt-2">
              <v-col>
                <h3>契約情報</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <div class="ml-2">
                  <!-- 回線番号 -->
                  <v-row>
                    <v-col cols="12">
                      <app-label-group
                        label="回線番号"
                        :value="contractReference.enumber"
                      />
                    </v-col>
                  </v-row>
                  <!-- メニュー -->
                  <v-row>
                    <v-col cols="12">
                      <app-label-group
                        label="メニュー"
                        :value="
                          $filter.enumTo(
                            contractReference.accessType,
                            'contractLineAccessType'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                  <!-- 契約者名 -->
                  <v-row>
                    <v-col cols="12">
                      <app-label-group
                        label="契約者名"
                        :value="contractReference.contractor"
                      />
                    </v-col>
                  </v-row>
                  <!-- エンドユーザ名 -->
                  <v-row>
                    <v-col cols="12">
                      <app-label-group
                        label="エンドユーザ名"
                        :value="contractReference.endUserName"
                      />
                    </v-col>
                  </v-row>

                  <template
                    v-if="
                      contractReference.accessType !== 'REMOTE_ACCESS_GW_FRE' &&
                      contractReference.accessType !== 'REMOTE_ACCESS_GW_CPA' &&
                      contractReference.accessType !== 'REMOTE_ACCESS_GW_CRG' &&
                      contractReference.accessType !==
                        'REMOTE_ACCESS_GW2_FRE' &&
                      contractReference.accessType !==
                        'REMOTE_ACCESS_GW2_CPA' &&
                      contractReference.accessType !== 'REMOTE_ACCESS_GW2_CRG'
                    "
                  >
                    <!-- 事務所名(拠点名) -->
                    <v-row>
                      <v-col cols="12">
                        <app-label-group
                          label="事務所名(拠点名)"
                          :value="contractReference.office"
                        />
                      </v-col>
                    </v-row>
                    <!-- 住所 -->
                    <v-row>
                      <v-col cols="12">
                        <app-label-group
                          label="住所"
                          :value="
                            $filter.emptyTo(contractReference.address, '-')
                          "
                        />
                      </v-col>
                    </v-row>
                    <!-- ビル名 -->
                    <v-row>
                      <v-col cols="12">
                        <app-label-group
                          label="ビル名"
                          :value="
                            $filter.emptyTo(contractReference.building, '-')
                          "
                        />
                      </v-col>
                    </v-row>
                    <!-- 帯域値 -->
                    <v-row>
                      <v-col cols="12">
                        <app-label-group
                          label="帯域値"
                          :value="
                            contractReference.bandwidth === null
                              ? '-'
                              : $filter.bandwidthTo(contractReference.bandwidth)
                          "
                        />
                      </v-col>
                    </v-row>
                    <!-- QoS -->
                    <v-row>
                      <v-col cols="12">
                        <app-label-group
                          label="QoS"
                          :value="
                            $filter.enumTo(contractReference.qos, 'contractQos')
                          "
                        />
                      </v-col>
                    </v-row>
                    <!-- VLAN制御 -->
                    <v-row>
                      <v-col cols="12">
                        <app-label-group
                          label="VLAN制御"
                          :value="
                            $filter.emptyTo(contractReference.vlanControl, '-')
                          "
                        />
                      </v-col>
                    </v-row>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { ContractListEntity } from "@/apis/ContractLineApi";

export default defineComponent({
  name: "ContractLineReference",
  props: {
    contractReference: {
      type: Object as PropType<ContractListEntity>,
      required: true,
    },
  },
});
</script>
